import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Education = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29.425 12.088L16.425 6.088C16.3 6.025 16.163 6 16.012 6C15.861 6 15.725 6.037 15.6 6.088L2.6 12.088C2.225 12.25 2 12.613 2 13C2 13.387 2.225 13.75 2.575 13.912L8 16.412V19.999C8 21.662 8.875 23.211 10.475 24.349C11.963 25.412 13.925 25.999 16 25.999C18.075 25.999 20.038 25.412 21.525 24.349C23.125 23.212 24 21.661 24 19.999V16.412L26 15.487V18.999C26 19.549 26.45 19.999 27 19.999C27.55 19.999 28 19.549 28 18.999V14.561L29.425 13.911C29.775 13.749 30 13.399 30 12.999C30 12.599 29.775 12.249 29.425 12.087V12.088ZM22 20C22 22.163 19.25 24 16 24C12.75 24 10 22.163 10 20V17.337L15.575 19.912C15.712 19.975 15.85 19.999 16 19.999C16.15 19.999 16.288 19.974 16.425 19.912L22 17.337V20ZM16 17.9L5.387 13L16 8.1L26.613 13L16 17.9Z" />
	</svg>
);

export default Education;
